import { PlentyGoalAccountFinancialEntity } from '@common/financialEntities';
import { Goal } from '@common/goals';
import { GoalType } from '@common/graphql/generated';
import { getGoalAccountOwnershipDetails } from '@common/react/goals';

export const getActionableGoalAccountForCurrentUser = (
    goalUnfiltered?: Goal
): PlentyGoalAccountFinancialEntity | undefined => {
    if (!goalUnfiltered) return;
    const details = getGoalAccountOwnershipDetails(goalUnfiltered);
    if (!details) return;

    return details.ownershipType === 'SPLIT'
        ? details.myGoalAccount
        : details.goalAccount;
};

export const getIncludeTargetStep = (goalType: GoalType) =>
    !['CASH_MANAGEMENT', 'RETIREMENT'].includes(goalType);
